import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "./Review.css";
//import Modification from "../../components/Review/QuotaConsumption";
import ReviewOrdersandQuota from "./reviewOrdersandQuota/ReviewOrdersandQuota";
import OrderDecision from "./orderDecision/OrderDecision";
import OrderModification from "./orderModification/OrderModification";
import { GetUserCountries, setState } from "./reviewSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function Review() {
  const dispatch = useDispatch();

  const state = useSelector((store) => store.review);
  const { isLoading, countries, NavValue } = state;

  const [value, setValue] = React.useState(NavValue);
  const pathname = useLocation().pathname.replace("/SiMS_ReactJS", "");

  const handleChange = (event, newValue) => {
    setValue(newValue);
    dispatch(setState("NavValue", newValue));
  };

  useEffect(() => {
    // if (countries.length <= 0) {
    dispatch(GetUserCountries({ method: "Get" }));
    //}
    setValue(0);
    dispatch(setState("NavValue", 0));
  }, []);

  useEffect(() => {
    setValue(NavValue);
  }, [NavValue]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={pathname}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="Review Order & Quota"
            sx={{ textTransform: "none" }}
            component={Link}
            to="order"
            value={"/review/order"}
          />
          <Tab
            label="Order Decision"
            sx={{ textTransform: "none" }}
            component={Link}
            to="orderdecision"
            value={"/review/orderdecision"}
          />
          <Tab
            label="Order Modification By Customer"
            sx={{ textTransform: "none" }}
            component={Link}
            to="ordermodification"
            value={"/review/ordermodification"}
          />
        </Tabs>
      </Box>
    </Box>
  );
}
